import React from 'react';
import { IService } from 'interfaces/services';
import Status from 'components/Status/Status';
import { convertDurationForFE } from 'utils/convertDuration';
import VisibilityDropdown from 'pages/ServicesPage/Table/VisibilityDropdown/VisibilityDropdown';
import CommonButton from 'components/CommonButton/CommonButton';
import { SERVICE_NAME } from 'utils/constants';
import { renderToast } from 'components/Toast/Toast';
import SplitSchedulingBadge from 'components/SplitSchedulingBadge/SplitSchedulingBadge';

interface IProps {
  service: IService;
  header?: React.ReactNode;
}

const ServiceDetails = ({ service, header }: IProps) => {
  const { id, name, isActive, duration, displayName, isSplitScheduling } =
    service;

  const isParentExamCleaningService = name === SERVICE_NAME.EXAM_CLEANING;
  const nameDisplay = displayName ? displayName : name;

  const handleCopyLink = async (shortLink: string) => {
    const cb = navigator.clipboard;
    await cb.writeText(shortLink);

    renderToast({
      type: 'success',
      message: 'Service link has been copied to clipboard',
    });
  };

  return (
    <div className="px-2 py-1.4 flex justify-between w-full">
      <div className="flex-1 max-w-[21rem]">
        {header ? (
          header
        ) : (
          <p className="text-16 leading-[2.4rem] font-bold ">
            <span>{nameDisplay}</span>
          </p>
        )}
        <p className="text-14 leading-21 truncate text-darkest-grey">
          {convertDurationForFE(duration)} minutes
        </p>
        <div className="mt-0.4 flex gap-x-0.5">
          <Status isActive={isActive}>
            {isActive ? 'Active' : 'Inactive'}
          </Status>
          {isSplitScheduling && (
            <SplitSchedulingBadge tooltipId={`splitScheduling-${id}`} />
          )}
        </div>
      </div>
      <div className="flex flex-col justify-between items-end">
        <VisibilityDropdown field={service} isClickable={false} />
        <CommonButton
          variant="secondary"
          className="!text-11 !leading-[1.8rem] !min-h-[2.6rem] !min-w-0 px-1 py-0.4"
          onClick={() => handleCopyLink(service.shortLink)}
        >
          {isParentExamCleaningService ? 'Copy Smart Link' : 'Copy Link'}
        </CommonButton>
      </div>
    </div>
  );
};

export default ServiceDetails;
